<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Monitor from "@/services/Monitor";
    import modalEditApiAlerts from '@/components/modals/monitor/modalEditApiAlerts';


    export default {
        components: { Layout, PageHeader, modalEditApiAlerts },
        page: {
            title: "API Alerts",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "API Alerts",
                items: [
                    {
                        text: "Logs",
                    },
                    {
                        text: "API Alerts",
                        active: true,
                    },
                ],
                isBusy: false,
                queuesData: {},
                showLoader:false,
                error: '',
                tableData: [],
                modalData: {},
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "timestamp",
                sortDesc: true,
                fields: [
                    {
                        key: "id",
                        label: "ID",
                        sortable: true
                    },
                    {
                        key: "app_id",
                        label: "App ID",
                        sortable: false
                    },
                    {
                        key: "env",
                        label: "ENV",
                        sortable: true
                    },
                    {
                        key: "tenant",
                        label: "Tenant",
                        sortable: true
                    },
                    {
                        key: "method",
                        label: "Method",
                        sortable: false
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true
                    },
                    {
                        key: "action",
                        label: "Action",
                        sortable: false
                    },
                    {
                        key: "response",
                        label: "Response",
                        sortable: false
                    },
                    {
                        key: "response_status",
                        label: "Response Status",
                        sortable: true,
                        class: "float-end"
                    },
                    {
                        key: "comment",
                        label: "Comment",
                        sortable: false
                    },
                    {
                        key: "timestamp",
                        label: "Timestamp",
                        sortable: true
                    },
                    {
                        key: "action_btns",
                        label: "Action",
                        sortable: false
                    },
                ]
            };
        },
        destroyed() {
            clearInterval(this.timer);
        },
        middleware: "authentication",
        async mounted() {
            try {
                await this.getApiAlerts();
                this.setupInterval();
            } catch (error) {
                console.error('Error during component initialization:', error);
            }
        },
        methods: {
            async getApiAlerts() {
                try {
                    this.filterData = true;
                    this.toggleBusy();
                    const response = await Monitor.getApiAlerts()
                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                } finally {
                    this.toggleBusy();
                }
            },

            setupInterval() {
                this.timer = setInterval(async () => {
                    try {
                        await this.getApiAlerts();
                    } catch (error) {
                        console.error('Error in interval:', error);
                    }
                },120000);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
          callModalEditApiAlerts(data) {
            this.$bvModal.show("apiAlerts_edit");
            this.modalData = data;
          },
        }
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                                <template v-slot:cell(action)="tableData">
                                     <span v-if="tableData.item.action && tableData.item.action.length > 20" class="text-nowrap">
                                        {{ tableData.item.action.slice(0, 20) + '... ' }}
                                        <a v-b-popover.hover.html.bottom="tableData.item.action" class="elementPointed float-end" title="Action" size="sm"><i class="uil uil-eye font-size-18"></i></a>
                                      </span>
                                    <span v-else>{{ tableData.item.action }}</span>
                                </template>

                                <template v-slot:cell(response)="tableData">
                                     <span v-if="tableData.item.response && tableData.item.response.length > 20" class="text-nowrap">
                                        {{ tableData.item.response.slice(0, 20) + '... ' }}
                                        <a v-b-popover.hover.html.bottom="tableData.item.response" class="elementPointed float-end" title="Response" size="sm"><i class="uil uil-eye font-size-18"></i></a>
                                      </span>
                                    <span v-else>{{ tableData.item.response }}</span>
                                </template>

                                <template v-slot:cell(comment)="tableData">
                                     <span v-if="tableData.item.comment && tableData.item.comment.length > 20" class="text-nowrap">
                                        {{ tableData.item.comment.slice(0, 20) + '... ' }}
                                        <a v-b-popover.hover.html.bottom="tableData.item.comment" class="elementPointed float-end" title="Comment" size="sm"><i class="uil uil-eye font-size-18"></i></a>
                                      </span>
                                    <span v-else>{{ tableData.item.comment }}</span>
                                </template>

                                <template v-slot:cell(action_btns)="tableData">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item d-flex">
                                             <a href="javascript:void(0);" class="px-2 text-primary" title="Edit Comment" @click="callModalEditApiAlerts(tableData.item)">
                                              <i class="uil uil-pen font-size-18"></i>
                                            </a>
                                            <a href="javascript:void(0);" class="px-2 text-primary" title="Copy Content" @click="copyToClipboard(tableData.item)">
                                                <i class="uil uil-copy font-size-18"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      --Modals--
      <modalEditApiAlerts :apiData="modalData" @onRefresh="getApiAlerts()"></modalEditApiAlerts>


    </Layout>
</template>
